import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '@core/auth/auth.service';
import { SidenavService } from '../sidenav.service';
import { ButtonComponent } from '@shared/ui/button/button.component';
import { ModalComponent } from '@shared/ui/modal/modal.component';
import { CompanyDropdownComponent } from '../company-dropdown/company-dropdown.component';

@Component({
  selector: 'app-header',
  imports: [RouterLink, ButtonComponent, ModalComponent, CompanyDropdownComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  protected readonly authService = inject(AuthService);
  protected readonly router = inject(Router);
  protected readonly sidenavService = inject(SidenavService);

  protected readonly isAccountModalOpen = signal(false);

  protected readonly userInitials = computed(() => {
    const user = this.authService.currentUser();
    if (!user) return '';
    return `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`.toUpperCase();
  });

  protected readonly displayName = computed(() => {
    const user = this.authService.currentUser();
    if (!user) return '';
    return `${user.firstName} ${user.lastName}`;
  });

  protected readonly userRoles = computed(() => this.authService.currentUser()?.roles ?? []);

  protected readonly userTenants = computed(() => this.authService.currentUser()?.tenants ?? []);

  protected openAccountModal(): void {
    this.isAccountModalOpen.set(true);
  }

  protected closeAccountModal(): void {
    this.isAccountModalOpen.set(false);
  }

  logout(): void {
    this.isAccountModalOpen.set(false);
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}
